import { createSelector } from 'reselect'
import { selectApplication } from './selectApplication'

export const selectIsHelplyCopilotOpen = createSelector(
  selectApplication,
  app => app.isHelplyCopilotOpen
)
